var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsUnreadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#262a2e",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.93-92.31q-29.85 0-51.04-21.24-21.2-21.24-21.2-51.07h144.62q0 29.93-21.26 51.12-21.26 21.19-51.12 21.19Zm.07-405.38ZM180-204.62v-59.99h72.31v-298.47q0-80.69 49.81-142.69 49.8-62 127.88-79.31V-810q0-20.83 14.57-35.42Q459.14-860 479.95-860q20.82 0 35.43 14.58Q530-830.83 530-810v8q-9.85 17.77-15.62 36.15-5.77 18.39-7.07 38.16-6.83-1.23-13.32-2.16-6.48-.92-13.99-.92-69.46 0-118.58 49.12-49.11 49.11-49.11 118.57v298.47h335.38v-250.08q13.77 4.92 29.08 7.69 15.31 2.77 30.92 2.39v240H780v59.99H180Zm519.27-387.3q-45.81 0-77.92-32.07-32.12-32.07-32.12-77.89 0-45.81 32.07-77.93 32.07-32.11 77.88-32.11 45.82 0 77.93 32.07 32.12 32.07 32.12 77.88 0 45.82-32.07 77.93-32.07 32.12-77.89 32.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsUnreadIcon);
export default __webpack_public_path__ + "static/media/notifications_unread_icon.dfc4620717901715fae4bad11b152e50.svg";
export { ForwardRef as ReactComponent };